// extracted by mini-css-extract-plugin
module.exports = {"trackingIcon":"tracking-icon_trackingIcon__1nGxP"};